<template>
  <div class="box__nav-inner">
    <div class="box__nav-logo">
      <i class="box__nav-logo--img"></i><span>{{ config.projectTitle }}</span>
    </div>
    <div class="box__nav-content">
      <el-link
        type="info"
        @click="routerTo('/')"
        class="box__nav-item"
        :underline="false"
        >首页</el-link
      >
      <el-link
        type="info"
        @click="routerTo('/connect')"
        class="box__nav-item"
        :underline="false"
        >联系我们</el-link
      >
      <!--  <el-link
        type="info"
        @click="routerTo('/about')"
        class="box__nav-item"
        :underline="false"
        >关于</el-link
      > -->
    </div>
  </div>
</template>

<script>
import config from "@/constant/common";
export default {
  name: "Header",
  data() {
    return {
      config,
      activeIndex: "1",
      activeIndex2: "1",
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    routerTo(path) {
      this.$emit("change", path === "/" ? false : true);
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.box__nav-inner {
  background-color: rgb(0, 100, 255);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  // border-bottom: 1px solid #d8d8d8;
  padding-bottom: 5px;
  position: relative;
  //background: #303133;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(to right, #f0f0f0, #f00, #0ff);
  }
}
.box__nav-logo {
  display: flex;
  align-items: center;
  font-size: 30px;
  color: #f0f0f0;
  .box__nav-logo--img {
    width: 50px;
    height: 50px;
    background: url(../assets/logo.png) no-repeat;
    border-radius: 50%;
    background-size: contain;
    margin-right: 10px;
  }
}
.box__nav-item {
  padding: 0 20px;
  color: #f0f0f0;
  line-height: 69px;
  transition: all ease 0.2s;
}
.box__nav-item:hover {
  background: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue